import InvestorCouponsError from './InvestorCouponsError';
class InvestorCouponIsNotRegistered extends InvestorCouponsError {
    constructor(options) {
        super('The investor coupon is not registered', options);
    }
}
export default InvestorCouponIsNotRegistered;
